module.exports = __webpack_public_path__ + "img/sangiovani_pinpoint.b49868ac.svg";